import * as Gmo from '@/infrastructure/network/Gmo/schema/models'
import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'
import { IOrderProps } from '@/entities/Order'

/**
 * カード編集URL取得
 *
 * カード編集URL取得
 */
export class GetLinkplusUrlMember implements APIRequest<Gmo.GetLinkplusUrlMemberResponse> {
  response: Gmo.GetLinkplusUrlMemberResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params: { RetUrl?: string; CompleteUrl?: string; CancelUrl?: string }
  constructor(params: { RetUrl?: string; CompleteUrl?: string; CancelUrl?: string }) {
    this.params = params
    this.path = '/payment/GetLinkplusUrlMember'
  }
}

/**
 * カード照会
 *
 * カード照会
 */
export class SearchCard implements APIRequest<Gmo.SearchCardResponse[]> {
  response: Gmo.SearchCardResponse[]
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor() {
    this.path = '/payment/SearchCard'
  }
}

/**
 * コンビニ決済の決済実行
 *
 * コンビニ決済の決済実行
 */
export class ExecTranCvs implements APIRequest<Monitaro.GetOrderResponse> {
  response: Monitaro.GetOrderResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: { code: string }
  constructor(id: string, code: string) {
    this.params = { code }
    this.path = `/payment/ExecTranCvs/${id}`
  }
}

/**
 * コンビニ決済のキャンセルの実行
 *
 * コンビニ決済のキャンセルの実行
 */
export class CvsCancel implements APIRequest<Monitaro.GetOrderResponse> {
  response: Monitaro.GetOrderResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  constructor(id: string) {
    this.path = `/payment/CvsCancel/${id}`
  }
}

/**
 * クレジットカード決済の取引開始
 *
 * クレジットカード決済の取引を開始する
 */
export class EntryTran implements APIRequest<Gmo.EntryTranResponse> {
  response: Gmo.EntryTranResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: IOrderProps
  constructor(id: string) {
    this.path = `/payment/EntryTran/${id}`
  }
}

/**
 * クレジットカード決済の実行
 *
 * クレジットカード決済を実行する
 */
export class ExecTran implements APIRequest<Gmo.ExecTranResponse> {
  response: Gmo.ExecTranResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: IOrderProps
  constructor(id: string) {
    this.path = `/payment/ExecTran/${id}`
  }
}
